import Vue from "vue";
import App from "./App.vue";
import router from "./../router/index";
import store from "./../store/index";
import axios from "axios";
import userModal from "./components/layout/components/userlistmodel";
import VueCompositionAPI from "@vue/composition-api";
import VueSweetalert2 from "vue-sweetalert2";
import IdleVue from "idle-vue";

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: process.env.VUE_APP_LOCKSCREEN_MINUTES * 60 * 1000,
});

import VueToggles from "vue-toggles";

Vue.component("VueToggles", VueToggles);
Vue.use(VueCompositionAPI);

import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";

import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

// https://www.npmjs.com/package/v-select2-component
import Select2 from "v-select2-component";
Vue.component("Select2", Select2);
Vue.component("Multiselect", Multiselect);
Vue.component("userModal", userModal);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// https://www.tiny.cloud/docs/integrations/vue/#tinymcevuejsintegrationquickstartguide
import Editor from "@tinymce/tinymce-vue";
// import Editor from './components/tinymce-wrapper'
import "@vueform/multiselect/themes/default.css";

Vue.component("Editor", Editor);

Vue.config.productionTip = false;

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

Vue.filter("truncate", function(value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + "...";
  }

  return value;
});

Vue.mixin({
  methods: {
    memberActive(member) {
      if (member.member_end === null) {
        return true;
      }

      if (
        Date.parse(new Date(member.member_end)) - Date.parse(new Date()) >
        0
      ) {
        return true;
      }

      return false;
    },
    get_permissions() {
      // console.log('all_leffit_modules',this.$store.state.leffit.user.all_leffit_modules);
    },
    formatPrice(value, symbol = false, code = false) {
      if (code) {
        if (code == "EUR") {
          symbol = "€";
        } else if (code == "DOL") {
          symbol = "$";
        }
      }
      let val = (value / 1).toFixed(2).replace(".", ",");
      return (
        symbol + " " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      );
    },
    capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),
    decodeEntities(encodedString) {
      return encodedString.replace(/&#(\d+);/g, function(match, dec) {
        return String.fromCharCode(dec);
      });
    },
    showTeaser(html_in, num_characters) {
      if (!html_in) {
        return "";
      }
      console.log(html_in, num_characters);
      return (
        html_in
          .split("")
          .slice(
            0,
            html_in.length <= num_characters ? num_characters : html_in.length
          )
          .join("") + "..."
      );
    },
    userHasRoles(roles) {
      let hasAccess = false;
      for (let i = 0; i < roles.length; i++) {
        if (
          this.$store.getters.userRolesName.includes(roles[i]) ||
          this.$store.getters.userRolesName.includes("Super-Admin")
        ) {
          hasAccess = true;
          break;
        }
      }

      return hasAccess;
    },
    userHasPermissions(permissions, allowLoggedInUser = false) {
      if (allowLoggedInUser) return true;

      let hasAccess = this.userHasRoles(["Super-Admin"]);

      if (hasAccess) return true;

      for (let i = 0; i < permissions.length; i++) {
        if (this.$store.getters.userPermissionsName.includes(permissions[i])) {
          hasAccess = true;
          break;
        }
      }

      return hasAccess;
    },
  },
});

store.dispatch("auth/me").then(() => {
  new Vue({
    router,
    store,
    created() {
      axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response) {
            if (error.response.status === 401) {
              this.$store.dispatch("logout");
            }
          }
          return Promise.reject(error);
        }
      );
    },
    render: (h) => h(App),
  }).$mount("#app");
});
